import { useMemo } from 'react';

import { collection, query, orderBy, Query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import ApplicationRequest from '../types/ApplicationRequest';

export default function useApplicationRequests() {
  const { isGod } = useAuth();
  const { userState } = useData();

  // Create the query reference
  const applicationRequestsQuery = useMemo(() => {
    if (!isGod) {
      return null;
    }
    if (userState.status !== 'ready' || !userState.userProfile) {
      return null;
    }

    return query(
      collection(firestore, 'applicationRequest'),
      orderBy('createTime', 'desc')
    ) as Query<ApplicationRequest>;
  }, [isGod, userState.userProfile, userState.status]);

  const [applicationRequests, isApplicationRequestsLoading, applicationRequestsError] =
    useCollectionData<ApplicationRequest>(applicationRequestsQuery);

  if (userState.status === 'logged_out') {
    return {
      applicationRequests: null,
      isApplicationRequestsLoading: false,
      applicationRequestsError: new Error('User must be logged in'),
    };
  }

  return {
    applicationRequests: applicationRequests || null,
    isApplicationRequestsLoading:
      isApplicationRequestsLoading ||
      userState.status === 'authenticating_user' ||
      userState.status === 'authenticating_profile' ||
      userState.status === 'authenticating_memberships',
    applicationRequestsError,
  };
}
